import { Component, ElementRef, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, HostListener } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ColorColumns } from '../color-table/color-table.interface';
import { GenericListDataReadAllPaginatedRequestDTO, GenericListUICDTO, GenericListUICUpdateRequestDTO, GenericListUICReorderDisplaySeqRequestDTO } from 'src/app/Common/UICServices/ListUIC/list-uic.interface';
import { ActionOptions, ActiveFilter, DateFilterCondition, FilterOption } from './uic-color-table.interface';
import { GenericListUicService } from 'src/app/Common/UICServices/ListUIC/list-uic.service';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-uic-color-table',
  templateUrl: './uic-color-table.component.html',
  styleUrls: ['./uic-color-table.component.css']
})
export class UicColorTableComponent implements OnInit, OnChanges {

@Output() dataLoaded = new EventEmitter<any[]>();
  @Output() selectionCheckBoxEvent: EventEmitter<{ checkstate: boolean, data: any }> = new EventEmitter()
  // @Output() handleColumnSorting: EventEmitter<{ currentPage: number, pageSize: number, orderByClause: string }> = new EventEmitter<{ currentPage: number, pageSize: number, orderByClause: string }>();
  @Input() EnableMultiSelect: boolean = false

  @Input() ReadAllDTO!: GenericListDataReadAllPaginatedRequestDTO;
  @Input() openColumnConfig: boolean = false;
  @Output() openColumnConfigChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('tableWrapper', { static: false }) tableWrapper?: ElementRef<HTMLElement>;
  @Output() inlineEditSave = new EventEmitter<any>();

  hideEditButton: boolean = false;

  onSelctionCheckboxChange(event: any, rowdata: any) {
    console.log(event?.target.checked);
    console.log(rowdata);
    this.selectionCheckBoxEvent.emit({ checkstate: event?.target.checked, data: rowdata })

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['uicListData']?.currentValue?.length > 0) {
      this.readyTableUI();
    }

    if (changes['routeData'] && !changes['uicListData']) {
      this.columns.forEach(col => {
        if (col.enableRouting) {
          col.routing = this.routeData;
        }
      });
    }

    if (changes['ReadAllDTO']) {
      // ALWAYS capture parent's WHERE clause and rebuild with active filters
      const incomingWhereClause = (changes['ReadAllDTO'].currentValue?.whereClause || '').trim();
      this.parentWhereClause = incomingWhereClause;
      
      // Create working copy from parent's DTO
      this.ReadAllDTO = changes['ReadAllDTO'].currentValue;
      this.workingReadAllDTO = JSON.parse(JSON.stringify(this.ReadAllDTO));
      
      // If columns are ready and we have active filters, rebuild the WHERE clause
      if (this.columns.length > 0 && Object.keys(this.activeFilters).length > 0) {
        // Rebuild WHERE clause to combine parent's clause + active filters
        this.rebuildWhereClause();
      }

      // Preserve user-applied column sort across parent DTO changes
      if (this.currentSortColumn && this.currentSortDirection) {
        this.workingReadAllDTO.orderByClause = `${this.currentSortColumn} ${this.currentSortDirection}`;
      }
    }

    if (changes['openColumnConfig']) {
      if (this.openColumnConfig) {
        if (!this.showColumnConfig) {
          this.openColumnConfigPopover();
        }
      } else {
        this.showColumnConfig = false;
      }
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(() => {
      this.applyColumnVisibilityFromQuery();
      // Filter restoration moved to readyTableUI() to ensure columns exist
    });
  }
  @Input() DataLoading: boolean = false

  WCColors = ["c584d3", "a084d2", "60a5e8", "60d9d9", "5ce7a1", "aae272", "fce153", "f8c459", "febc5a", "eb8a5b"];
  @Input() uicListData: GenericListUICDTO[] = []
  @Input() routeData: { route: string, id: string, queryParams?: { [key: string]: any }; } = { route: '', id: '' }
  columns: ColorColumns[] = [];
  @Input() tableData: any[] = [];

  @Input() enableInlineButton: { buttonName: string, buttonClass: string, actionHandler: (rowData: any) => void, isLoading?: boolean } | null = null;
  @Input() enableCheckboxColumn: boolean = false;
  @Input() toggleStatus: boolean = false;
  @Input() checkboxColumnLabel: string = 'Select';
  @Input() enableActionColumn: boolean = false;
  @Input() actionColumnLabel: string = 'Actions';
  @Input() actionOptions: ActionOptions[] = [];
  @Input() checkboxStateBinding: string = 'isActive';
  @Input() enableBadge: string = ''
  @Input() enableAutoSerial: boolean = false
  @Input() enableInlineEditing: boolean = false
  minVisibleColumns: number = 3;

  UICListService = inject(GenericListUicService)
  User = inject(UserLoginService).User()
  sanitizer = inject(DomSanitizer)
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private http = inject(HttpClient);
  private columnConfigQueryParam = 'uicCols';
  private filterConfigQueryParam = 'uicFilters';
  masterSelected: boolean = false;

  // ========== FILTER STATE MANAGEMENT ==========
  activeFilters: { [columnKey: string]: ActiveFilter } = {};
  filterOptions: { [columnKey: string]: FilterOption[] } = {};
  selectedFilterValues: { [columnKey: string]: any[] } = {};
  openFilterPopupKey: string | null = null;
  filterPopupPosition: { top: string; left: string } = { top: '0', left: '0' };
  filterLoadingKey: string | null = null;
  filterPopupElement: HTMLElement | null = null;
  filterSearchText: { [columnKey: string]: string } = {};
  dateFilterCondition: { [columnKey: string]: DateFilterCondition } = {};
  dateFilterValidationError: { [columnKey: string]: string } = {};
  readonly dateFilterConditionOptions: Array<{ value: DateFilterCondition; label: string }> = [
    { value: 'eq', label: 'Equal To' },
    { value: 'gt', label: 'Is Greater Than' },
    { value: 'lt', label: 'Is Less Than' },
    { value: 'between', label: 'Is Between' }
  ];
  parentWhereClause: string = '';  // Store parent component's WHERE clause - NEVER modified by filters
  workingReadAllDTO!: GenericListDataReadAllPaginatedRequestDTO;  // Working copy to prevent mutations to parent's DTO
  // @Input() routeOption : {enable:boolean,route:string,colName: string,col}

  currentSortColumn: string = '';
  currentSortDirection: 'ASC' | 'DESC' | '' = '';

  @Output() checkboxChange: EventEmitter<{ rowData: any, isChecked: boolean }> = new EventEmitter<{ rowData: any, isChecked: boolean }>();
  @Output() actionClick: EventEmitter<{ actionName: string, rowData: any, action?: string }> = new EventEmitter<{ actionName: string, rowData: any, action?: string }>();
  @Output() buttonClick: EventEmitter<{ buttonAction: string, rowData: any }> = new EventEmitter<{ buttonAction: string, rowData: any }>();
  private setTableDataAndEmit(data: any[]) {
    this.tableData.splice(0, this.tableData.length, ...data);
    this.dataLoaded.emit(data);
  }


  onCheckboxChange(row: any) {
    const isChecked = row[this.checkboxStateBinding];
    const rowData = row
    this.checkboxChange.emit({ rowData, isChecked });
    this.checkIfAllSelected();
  }


  positionDropdown(event: MouseEvent): void {
    const btn = event.currentTarget as HTMLElement;
    setTimeout(() => {
      const menu = btn.closest('.btn-group')?.querySelector('.dropdown-menu') as HTMLElement | null;
      if (!menu || !menu.classList.contains('show')) return;
      const rect = btn.getBoundingClientRect();
      const menuHeight = menu.offsetHeight || 200;
      const top = (window.innerHeight - rect.bottom) >= menuHeight
        ? rect.bottom
        : rect.top - menuHeight;
      Object.assign(menu.style, {
        position: 'fixed',
        inset: 'auto',
        top: top + 'px',
        left: rect.left + 'px',
        transform: 'none',
        zIndex: '9999',
        margin: '0',
      });
    }, 0);
  }

  actionButtonClick(actionName: any, rowData: any) {
    this.actionClick.emit({ actionName, rowData });
  }

  onButtonClick(buttonAction: string, rowData: any) {
    console.log('Button clicked:', buttonAction, rowData);
    this.buttonClick.emit({ buttonAction, rowData });
  }

  getLowerCaseValue(row: any, colKey: string) {
    const lowerCaseKey = colKey.toLowerCase().trim();
    const matchingKey = Object.keys(row).find(key => key.toLowerCase().trim() == lowerCaseKey);
    return matchingKey ? row[matchingKey] : null;
  }

  // Bypass Angular security to allow trusted HTML with scripts from backend
  getTrustedHtml(html: string): SafeHtml {
    if (!html) return '';
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  readyTableUI() {
    this.columns = [];
    this.columnVisibilityState = {};

    this.uicListData.forEach((element) => {
      let col: ColorColumns = {
        colName: element.uiLabel,
        colData: element.propertyName,
        colStyle: element.uiStyle,
        sortBy: element.whereClauseName ?? '',
        colWidth: (element.headerWidth && element.headerWidth > 0) ? element.headerWidth : 120,
        otherDetails: element.otherDetails
      };


        if (element.dataType && element.dataType.toLowerCase() == 'date') {
          col.isDate = true
        }

        // Handle HTML content rendering
        if (element.dataType && element.dataType.toLowerCase() === 'html') {
          col.isHtml = true;
        }

        if (element.otherDetails && element.otherDetails.toLowerCase() == 'routing') {
          col.enableRouting = true
          col.routing = this.routeData
        }

        // Handle button columns (customAttribute starts with 'Print' or 'Button')
        if (element.customAttribute && (element.customAttribute.toLowerCase().startsWith('print') || element.customAttribute.toLowerCase().startsWith('button'))) {
          col.isButton = true;
          col.buttonIcon = element.uiClass || 'bi-printer';
          col.buttonAction = element.customAttribute;
        }
        // Handle badge columns
        else if (element.otherDetails && element.otherDetails.toLowerCase() === 'badge') {
          col.isBadge = true;
          col.badgeColor = element.uiClass || ''; // Use uiClass for badge color
        }
        // 🔥 ASSIGN uiClass to colClass for custom HTML injection
        else if (element.uiClass) {
          col.colClass = element.uiClass;
        }

        // ========== FILTER METADATA MAPPING ==========
        col.filterInputType = element.filterInputType ?? '';
        col.filterDataFetchType = element.filterDataFetchType ?? '';
        col.filterDataFetchFrom = element.filterDataFetchFrom ?? '';
        col.filterDataPatchName = element.filterDataPatchName ?? '';
        col.filterDataDisplayName = element.filterDataDisplayName ?? '';
        col.whereClauseName = element.whereClauseName ?? '';  // Map whereClauseName for WHERE clause generation
        col.dataType = element.dataType ?? '';

      this.columns.push(col);
      this.columnVisibilityState[col.colData] = element.isUIVisible === 1;
    });

    // After columns are generated
    this.initializeColumnVisibility();
    // Now restore filters from query params (columns are ready)
    this.applyFiltersFromQuery();
  }


  initializeColumnVisibility() {
    this.columns.forEach((col) => {
      if (this.columnVisibilityState[col.colData] === undefined) {
        this.columnVisibilityState[col.colData] = true;
      }
    });

    this.visibleColumns = this.columns.filter(col => this.columnVisibilityState[col.colData]);

    this.applyColumnVisibilityFromQuery();
    this.firstConfigurableColumnIndex = this.getFirstConfigurableColumnIndex(this.visibleColumns);
    
    // Restore filter UI state after column visibility is set
    this.restoreFilterUIState();
  }


  getFirstConfigurableColumnIndex(targetColumns: ColorColumns[]): number {
    return targetColumns.findIndex(col => {

      // Ignore button columns
      if (col.isButton) return false;

      // Normalize header text
      const header = (col.colName || '').toLowerCase().replace(/\s|\./g, '');

      // Ignore serial-like headers
      const isSerial =
        header === 'sr' ||
        header === 'srno' ||
        header === 'serial' ||
        header === 'serialno';

      return !isSerial;
    });
  }



  toggleColumnConfig(event: MouseEvent) {
    event.stopPropagation();
    this.setColumnConfigPositionFromEvent(event);
    this.onColumnVisibilityChange();
    this.showColumnConfig = !this.showColumnConfig;
    
    // Initialize configColumnOrder and save original order when opening config panel
    if (this.showColumnConfig) {
      this.configColumnOrder = [...this.getConfigurableColumns()];
      this.originalColumnOrder = [...this.configColumnOrder];
      this.draggedColumns.clear();  // Reset dragged columns tracking
    }
    
    this.openColumnConfigChange.emit(this.showColumnConfig);
  }

  openColumnConfigPopover() {
    this.setColumnConfigPositionDefault();
    this.onColumnVisibilityChange();
    this.showColumnConfig = true;
    
    // Initialize configColumnOrder and save original order when opening config panel
    this.configColumnOrder = [...this.getConfigurableColumns()];
    this.originalColumnOrder = [...this.configColumnOrder];
    this.draggedColumns.clear();  // Reset dragged columns tracking
  }


  applyColumnVisibility() {
    const selectedCount = this.getSelectedColumnCount();
    const minVisible = this.getMinVisibleColumns();
    if (selectedCount < minVisible) {
      this.columnVisibilityError = `Select at least ${minVisible} columns.`;
      return;
    }

    this.columns.forEach(col => {
      if (this.columnVisibilityState[col.colData] === undefined) {
        this.columnVisibilityState[col.colData] = true;
      }
    });

    // === APPLY NEW COLUMN ORDER from configColumnOrder ===
    this.updateColumnsOrder(this.configColumnOrder);

    // === PERSIST COLUMN ORDER TO DATABASE ===
    // Only call API for columns that were explicitly dragged by the user
    // The stored procedure will automatically renumber all other columns
    this.configColumnOrder.forEach((col, newIndex) => {
      // Only process columns that were actually dragged by the user
      if (!this.draggedColumns.has(col.colData)) {
        return;
      }
      
      // Find the corresponding uicListData entry to get configId, masterType, and ORIGINAL displaySeq
      const colToUpdate = this.uicListData.find(uicCol => uicCol.propertyName === col.colData);
      if (!colToUpdate || !colToUpdate.configId) {
        console.warn(`Could not find configId for column ${col.colData}`);
        return;
      }

      const originalDisplaySeq = colToUpdate.displaySeq || 0;
      let newDisplaySeq = newIndex + 1; // 1-based indexing
      
      // CRITICAL FIX: When dragging DOWN (to a higher position), 
      // we need to add 1 to account for the fact that the dragged item
      // will be inserted AFTER other items shift up to fill its old position
      if (originalDisplaySeq < newDisplaySeq) {
        newDisplaySeq = newDisplaySeq + 1;
      }

      const requestData: GenericListUICReorderDisplaySeqRequestDTO = {
        tenantId: this.User.companyId,
        masterType: colToUpdate.masterType ?? '',
        configId: colToUpdate.configId,
        newDisplaySeq: newDisplaySeq,
        actionUser: this.User.userId.toString()
      };

      console.log(`Calling API for dragged column: ${col.colData}, original pos: ${originalDisplaySeq}, new position: ${newDisplaySeq}`);

      this.UICListService.GenericListUIC_ReorderDisplaySeq(requestData).subscribe({
        next: (response: any) => {
          if (response.status !== 1) {
            console.error(`Failed to update display sequence for column ${col.colData}:`, response.message);
          } else {
            console.log(`Successfully updated ${col.colData} to position ${newDisplaySeq}`);
          }
        },
        error: (error: any) => {
          console.error(`Error updating display sequence for column ${col.colData}:`, error);
        }
      });
    });
    
    // Clear the dragged columns set after applying
    this.draggedColumns.clear();

    this.visibleColumns = this.columns.filter(col =>
      this.columnVisibilityState[col.colData]
    );
    this.visibleColumns = [...this.visibleColumns];
    this.firstConfigurableColumnIndex = this.getFirstConfigurableColumnIndex(this.visibleColumns);
    this.columnVisibilityError = '';
    this.showColumnConfig = false;
    this.openColumnConfigChange.emit(false);
    this.updateColumnVisibilityQuery();
  }

  cancelColumnVisibility() {
    this.showColumnConfig = false;
    this.openColumnConfigChange.emit(false);
    this.draggedColumns.clear();  // Clear tracked drags on cancel
  }

  onColumnVisibilityChange() {
    const selectedCount = this.getSelectedColumnCount();
    const minVisible = this.getMinVisibleColumns();
    this.columnVisibilityError = selectedCount < minVisible
      ? `Select at least ${minVisible} columns.`
      : '';
  }

  getSelectedColumnCount(): number {
    return this.columns.filter(col => this.columnVisibilityState[col.colData]).length;
  }

  canToggleColumn(col: ColorColumns): boolean {
    const selectedCount = this.getSelectedColumnCount();
    const minVisible = this.getMinVisibleColumns();
    return !(this.columnVisibilityState[col.colData] && selectedCount <= minVisible);
  }

  getMinVisibleColumns(): number {
    return Math.min(this.minVisibleColumns, this.columns.length || this.minVisibleColumns);
  }

  /**
   * Get only columns that are marked as configurable (isUIVisible = 1)
   * These are the columns that should appear in the Column Settings checklist
   */
  getConfigurableColumns(): ColorColumns[] {
    // Find the uicListData entries that have isUIVisible = 1
    const configurableData = this.uicListData.filter(item => item.isUIVisible === 1);
    const configurableColumnNames = new Set(configurableData.map(item => item.propertyName));
    
    // Filter columns to only those that are in configurableData
    return this.columns.filter(col => configurableColumnNames.has(col.colData));
  }

  /**
   * Drag start handler for column reordering
   */
  onDragStart(event: DragEvent, index: number) {
    this.draggedColumnIndex = index;
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/html', (event.target as HTMLElement).innerHTML);
    }
  }

  /**
   * Drag over handler for column reordering
   */
  onDragOver(event: DragEvent, index: number) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move';
    }
    this.dragOverIndex = index;
  }

  /**
   * Drag leave handler
   */
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    this.dragOverIndex = null;
  }

  /**
   * Drop handler for column reordering
   */
  onDrop(event: DragEvent, index: number) {
    event.preventDefault();
    event.stopPropagation();
    
    if (this.draggedColumnIndex === null || this.draggedColumnIndex === index) {
      this.draggedColumnIndex = null;
      this.dragOverIndex = null;
      return;
    }

    // Reorder the configColumnOrder array
    const draggedItem = this.configColumnOrder[this.draggedColumnIndex];
    
    // Track that this column was explicitly dragged by the user
    this.draggedColumns.add(draggedItem.colData);
    
    this.configColumnOrder.splice(this.draggedColumnIndex, 1);
    this.configColumnOrder.splice(index, 0, draggedItem);

    this.draggedColumnIndex = null;
    this.dragOverIndex = null;
  }

  /**
   * Drag end handler
   */
  onDragEnd() {
    this.draggedColumnIndex = null;
    this.dragOverIndex = null;
  }

  /**
   * Update columns order by reordering the columns array
   */
  private updateColumnsOrder(newOrder: ColorColumns[]) {
    // Create a new columns array with the new order
    const newColumns: ColorColumns[] = [];
    
    newOrder.forEach(orderedCol => {
      const columnToMove = this.columns.find(col => col.colData === orderedCol.colData);
      if (columnToMove) {
        newColumns.push(columnToMove);
      }
    });

    // Add any columns that were not in the configurable list (e.g., action columns)
    this.columns.forEach(col => {
      if (!newColumns.find(nc => nc.colData === col.colData)) {
        newColumns.push(col);
      }
    });

    this.columns = newColumns;
  }

  /**
   * Store column order in query params
   */
  private applyColumnVisibilityFromQuery() {
    if (!this.columns.length) return;

    const rawValue = this.route.snapshot.queryParamMap.get(this.columnConfigQueryParam);
    if (!rawValue) return;

    const visibleSet = new Set(
      rawValue
        .split(',')
        .map(value => value.trim())
        .filter(value => value.length > 0)
    );

    if (!visibleSet.size) return;

    this.columns.forEach(col => {
      this.columnVisibilityState[col.colData] = visibleSet.has(col.colData);
    });

    const selectedCount = this.getSelectedColumnCount();
    const minVisible = this.getMinVisibleColumns();
    if (selectedCount < minVisible) {
      this.columns.forEach(col => {
        this.columnVisibilityState[col.colData] = true;
      });
    }

    this.visibleColumns = this.columns.filter(col => this.columnVisibilityState[col.colData]);
    this.firstConfigurableColumnIndex = this.getFirstConfigurableColumnIndex(this.visibleColumns);
  }

  private updateColumnVisibilityQuery() {
    const visibleColumns = this.columns
      .filter(col => this.columnVisibilityState[col.colData])
      .map(col => col.colData);

    const paramValue = visibleColumns.length === this.columns.length
      ? null
      : visibleColumns.join(',');

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { [this.columnConfigQueryParam]: paramValue },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }


  toggleSelectAll() {
    this.tableData.forEach(row => {
      row.isSelected = this.masterSelected;
      this.selectionCheckBoxEvent.emit({ checkstate: this.masterSelected, data: row });
    });
  }

  checkIfAllSelected() {
    this.masterSelected = this.tableData.every(row => row.isSelected === true);
  }


  checkActionOptionCondition(option: any, row: any): boolean {

    if (!option?.conditionField) return true;
    return row?.[option.conditionField] === option.conditionValue;

  }


  columnSortClick(sortBy: string) {
    // Prevent sorting if we just finished dragging
    if (this.wasDragging) {
      return;
    }
    console.log(this.ReadAllDTO, 'readalldto')
    if (!sortBy) return;

    // Toggle sort direction
    if (this.currentSortColumn === sortBy) {
      // Same column clicked - toggle direction
      if (this.currentSortDirection === 'ASC') {
        this.currentSortDirection = 'DESC';
      } else if (this.currentSortDirection === 'DESC') {
        // Reset to no sort
        this.currentSortDirection = '';
        this.currentSortColumn = '';
        // this.handleColumnSorting.emit({ currentPage: 1, pageSize: 10, orderByClause: '' });

        this.workingReadAllDTO.pageNo = 1;
        this.workingReadAllDTO.orderByClause = '';
        this.DataLoading = true;
        this.UICListService.GenericListData_ReadAllPaginated(this.workingReadAllDTO).subscribe(res => {
          this.setTableDataAndEmit(res);
          this.DataLoading = false;
        });
        return;
      } else {
        this.currentSortDirection = 'ASC';
      }
    } else {
      // New column clicked - start with ASC
      this.currentSortColumn = sortBy;
      this.currentSortDirection = 'ASC';
    }

    const sortString = sortBy + ' ' + this.currentSortDirection;
    console.log(sortString);
    // this.handleColumnSorting.emit({ currentPage: 1, pageSize: 10, orderByClause: sortString });
    this.workingReadAllDTO.pageNo = 1;
    this.workingReadAllDTO.orderByClause = sortString;
    this.DataLoading = true;
    this.UICListService.GenericListData_ReadAllPaginated(this.workingReadAllDTO).subscribe(res => {
      this.setTableDataAndEmit(res);
      this.DataLoading = false;
    });
  }

  getSortIcon(columnSortBy: string): string {
    if (this.currentSortColumn !== columnSortBy) {
      return 'bi-arrow-down-up'; // Neutral/unsorted icon
    }
    return this.currentSortDirection === 'ASC' ? 'bi-arrow-up' : 'bi-arrow-down';
  }

  /*--------------------------------------*/

  private startX = 0;
  private startWidth = 0;
  resizingColumn: ColorColumns | null = null;
  private wasDragging = false;

  startResize(event: MouseEvent, col: ColorColumns) {

    event.preventDefault();
    event.stopPropagation(); // very important: prevents sort click

    this.resizingColumn = col;
    this.startX = event.pageX;
    this.startWidth = col.colWidth ? Number(col.colWidth) : 120;
    this.wasDragging = false;

    document.addEventListener('mousemove', this.onResizing);
    document.addEventListener('mouseup', this.stopResize);
  }

  onResizing = (event: MouseEvent) => {
    if (!this.resizingColumn) return;

    this.wasDragging = true; // Mark that dragging occurred
    const diff = event.pageX - this.startX;
    const newWidth = this.startWidth + diff;

    // minimum width safety
    if (newWidth > 50) {
      this.resizingColumn.colWidth = newWidth;
    }
  };

  stopResize = () => {
    const resizedColumn = this.resizingColumn;
    const finalWidth = resizedColumn?.colWidth || 0;

    this.resizingColumn = null;
    document.removeEventListener('mousemove', this.onResizing);
    document.removeEventListener('mouseup', this.stopResize);

    // Log the resize result
    if (resizedColumn && this.wasDragging) {

      const colToUpdate = this.uicListData.find(col => col.propertyName === resizedColumn.colData);
      if (colToUpdate) {
        colToUpdate.headerWidth = finalWidth;

        this.DataLoading = true;

        let data: GenericListUICUpdateRequestDTO = {
          masterType: colToUpdate.masterType ?? '',
          configId: colToUpdate.configId ?? 0,
          tenantId: colToUpdate.tenantId ?? 0,
          tenantBranchId: colToUpdate.tenantBranchId ?? 0,
          propertyName: colToUpdate.propertyName ?? '',
          uiId: colToUpdate.uiId ?? '',
          uiLabel: colToUpdate.uiLabel ?? '',
          uiStyle: colToUpdate.uiStyle ?? '',
          uiClass: colToUpdate.uiClass ?? '',
          isUIVisible: colToUpdate.isUIVisible ?? 0,
          displaySeq: colToUpdate.displaySeq ?? 0,
          headerWidth: finalWidth,
          filtering: colToUpdate.filtering ?? '',
          filterInputType: colToUpdate.filterInputType ?? '',
          filterDataFetchType: colToUpdate.filterDataFetchType ?? '',
          filterDataFetchFrom: colToUpdate.filterDataFetchFrom ?? '',
          filterDataPatchName: colToUpdate.filterDataPatchName ?? '',
          filterDataDisplayName: colToUpdate.filterDataDisplayName ?? '',
          whereClauseName: colToUpdate.whereClauseName ?? '',
          customAttribute: colToUpdate.customAttribute ?? '',
          otherDetails: colToUpdate.otherDetails ?? '',
          dataType: colToUpdate.dataType ?? '',
          isActive: colToUpdate.isActive ?? 0,
          actionUser: this.User.userId.toString()
        }
        this.UICListService.GenericListUIC_Update(data).subscribe({
          next: (res) => {
            this.DataLoading = false;
            console.log('Column resized:', resizedColumn.colName, 'New width:', finalWidth);
          },
          error: (err) => {
            this.DataLoading = false;
            console.error('Error updating column width:', err);
          }
        });
      }
    }

    // Prevent click event from firing after drag
    if (this.wasDragging) {
      setTimeout(() => {
        this.wasDragging = false;
      }, 10);
    }
  };





  ReadAllPaginated(data: GenericListDataReadAllPaginatedRequestDTO) {
    // === CRITICAL: Keep reference to original DTO for property access ===
    this.ReadAllDTO = data;
    
    // === Create a DEEP COPY to prevent mutations to parent's DTO ===
    this.workingReadAllDTO = JSON.parse(JSON.stringify(data));
    
    // === CRITICAL: Capture parent's whereClause ONLY from the incoming data ===
    this.parentWhereClause = (data.whereClause || '').trim();
    
    // === Rebuild WHERE clause combining parent's clause + active filters ===
    this.rebuildWhereClause();

    // === Preserve user-applied column sort across pagination ===
    if (this.currentSortColumn && this.currentSortDirection) {
      this.workingReadAllDTO.orderByClause = `${this.currentSortColumn} ${this.currentSortDirection}`;
    }
    
    // Make API call with combined WHERE clause (use working copy)
    this.DataLoading = true;
    this.UICListService.GenericListData_ReadAllPaginated(this.workingReadAllDTO).subscribe(res => {
      this.setTableDataAndEmit(res);
      this.DataLoading = false;
    });
  }

  encodeRowData(row: any): string {
    return encodeURIComponent(JSON.stringify(row));
  }


  visibleColumns: ColorColumns[] = [];
  columnVisibilityState: { [key: string]: boolean } = {};
  showColumnConfig: boolean = false;
  firstConfigurableColumnIndex: number = -1;

  columnVisibilityError: string = '';
  columnConfigPosition: { top: string; right?: string; left?: string } = { top: '36px', right: '20px' };

  // ========== COLUMN REORDERING STATE ==========
  configColumnOrder: ColorColumns[] = [];  // Temp order for column config popup
  originalColumnOrder: ColorColumns[] = [];  // Original order to compare against
  draggedColumnIndex: number | null = null;  // Track which column is being dragged
  dragOverIndex: number | null = null;  // Track which column is being dragged over
  draggedColumns: Set<string> = new Set();  // Track which columns were explicitly dragged by user

  private setColumnConfigPositionDefault() {
    this.columnConfigPosition = { top: '36px', right: '20px' };
  }

  private setColumnConfigPositionFromEvent(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement | null;
    const wrapper = this.tableWrapper?.nativeElement || null;

    if (!target || !wrapper) {
      this.setColumnConfigPositionDefault();
      return;
    }

    const targetRect = target.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();

    const top = targetRect.bottom - wrapperRect.top + 6;
    const left = Math.max(0, targetRect.right - wrapperRect.left - 220);

    this.columnConfigPosition = { top: `${top}px`, left: `${left}px` };
  }



  onInlineEditClick(row: any, col: any) {
    this.hideEditButton = true;
    row._editingColumn = col.colData;

    // store original value (for cancel)
    row._originalValue = row[col.colData];
  }

  onInlineEditSave(row: any, col: any) {
    this.hideEditButton = false;
    const field = col.colData;
    const value = row[field];

    console.log("Saving:", field, value);

    row._editingColumn = null;

    // Emit event to parent
    this.inlineEditSave.emit({
      rowData: row,
      field: field,
      value: value,
      column: col
    });
  }

  onInlineEditCancel(row: any, col: any) {
    this.hideEditButton = false;
    const field = col.colData;

    // restore original value
    row[field] = row._originalValue;

    row._editingColumn = null;
  }
  // ========== FILTER METHODS ==========

  /**
   * Check if a column should show the filter icon
   * Filter shows only if FilterInputType is defined
   * FilterInputType tells us the UI: 'textbox' or 'select'
   */
  shouldShowFilterIcon(col: ColorColumns): boolean {
    return !!(col.filterInputType && col.filterInputType.trim());
  }

  /**
   * Check if a filter is currently active on a column
   */
  isFilterActive(columnKey: string): boolean {
    const filter = this.activeFilters[columnKey];
    if (!filter) return false;

    if (filter.selectedValues && filter.selectedValues.length > 0) return true;
    if (filter.filterText && filter.filterText.trim()) return true;
    if (filter.filterDate) return true;
    if (filter.filterFromDate || filter.filterToDate) return true;

    return false;
  }

  isDateFilterColumn(col: ColorColumns): boolean {
    const inputType = this.getFilterInputType(col);
    const fetchType = this.getFilterDataFetchType(col);
    return inputType === 'date' || col.dataType?.toLowerCase() === 'date' || fetchType === 'date';
  }

  getDateFilterCondition(columnKey: string): DateFilterCondition {
    return this.dateFilterCondition[columnKey] || 'eq';
  }

  onDateFilterConditionChange(columnKey: string, condition: DateFilterCondition) {
    this.dateFilterCondition[columnKey] = condition;
    this.dateFilterValidationError[columnKey] = '';

    if (condition === 'between') {
      const currentSingleDate = this.filterSearchText[columnKey] || '';
      if (currentSingleDate && !this.filterSearchText[columnKey + '_from']) {
        this.filterSearchText[columnKey + '_from'] = currentSingleDate;
      }
      this.filterSearchText[columnKey] = '';
      return;
    }

    const fallbackDate =
      this.filterSearchText[columnKey] ||
      this.filterSearchText[columnKey + '_from'] ||
      this.filterSearchText[columnKey + '_to'] ||
      '';

    this.filterSearchText[columnKey] = fallbackDate;
    this.filterSearchText[columnKey + '_from'] = '';
    this.filterSearchText[columnKey + '_to'] = '';
  }

  clearDateFilterInputState(columnKey: string) {
    this.filterSearchText[columnKey] = '';
    this.filterSearchText[columnKey + '_from'] = '';
    this.filterSearchText[columnKey + '_to'] = '';
    this.dateFilterValidationError[columnKey] = '';
  }

  buildDateFilterPayload(columnKey: string): { condition: DateFilterCondition; date?: string; fromDate?: string; toDate?: string } {
    const condition = this.getDateFilterCondition(columnKey);
    return {
      condition,
      date: this.filterSearchText[columnKey] || '',
      fromDate: this.filterSearchText[columnKey + '_from'] || '',
      toDate: this.filterSearchText[columnKey + '_to'] || ''
    };
  }

  /**
   * Get filter input type for UI determination
   * Determines: textbox vs select/dropdown
   */
  getFilterInputType(col: ColorColumns): string {
    return (col.filterInputType || '').toLowerCase();
  }

  /**
   * Get filter data fetch type
   * Determines HOW to fetch data: api, text, valuelist, etc.
   * (Similar to Uic-Form's dataFetchType)
   */
  getFilterDataFetchType(col: ColorColumns): string {
    return (col.filterDataFetchType || 'text').toLowerCase();
  }

  /**
   * Open filter popup for a column
   */
  openFilterPopup(event: MouseEvent, col: ColorColumns) {
    event.stopPropagation();

    if (this.openFilterPopupKey === col.colData) {
      this.closeFilterPopup();
      return;
    }

    this.closeFilterPopup();
    this.openFilterPopupKey = col.colData;

    // Set popup position relative to filter icon
    const target = event.currentTarget as HTMLElement;
    if (target) {
      const rect = target.getBoundingClientRect();
      const wrapper = this.tableWrapper?.nativeElement;

      if (wrapper) {
        const wrapperRect = wrapper.getBoundingClientRect();
        const popupWidth = 260;
        const popupHeight = 360;
        const padding = 8;

        const preferredTop = rect.bottom - wrapperRect.top + 8;
        const preferredLeft = rect.left - wrapperRect.left - 150;

        const minLeft = 0;
        const maxLeftByWrapper = Math.max(minLeft, wrapper.clientWidth - popupWidth - padding);

        const maxLeftByViewport = Math.max(
          minLeft,
          window.innerWidth - wrapperRect.left - popupWidth - padding
        );

        const maxLeft = Math.min(maxLeftByWrapper, maxLeftByViewport);
        const left = Math.min(Math.max(preferredLeft, minLeft), maxLeft);

        const popupBottomInViewport = wrapperRect.top + preferredTop + popupHeight;
        const shouldOpenUpwards = popupBottomInViewport > (window.innerHeight - padding);

        const top = shouldOpenUpwards
          ? Math.max(padding, rect.top - wrapperRect.top - popupHeight - 8)
          : preferredTop;

        this.filterPopupPosition = {
          top: `${top}px`,
          left: `${left}px`
        };
      }
    }

    // Load filter options if needed
    if (col.filterDataFetchType?.toLowerCase() === 'api') {
      this.loadFilterOptions(col);
    }

    if (this.isDateFilterColumn(col)) {
      const existingFilter = this.activeFilters[col.colData];
      this.dateFilterCondition[col.colData] = this.resolveDateCondition(existingFilter);
      this.dateFilterValidationError[col.colData] = '';
    }

    // Attach click-outside listener
    setTimeout(() => {
      document.addEventListener('click', this.filterPopupClickOutsideListener);
    }, 100);
  }

  /**
   * Close filter popup
   */
  closeFilterPopup() {
    this.openFilterPopupKey = null;
    document.removeEventListener('click', this.filterPopupClickOutsideListener);
  }

  /**
   * TrackBy function for filter options list (improves change detection)
   */
  trackByFilterOption(index: number, item: FilterOption): any {
    return item.key;  // TrackBy using unique key value
  }

  private filterPopupClickOutsideListener = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest('.filter-popup-wrapper')) {
      this.closeFilterPopup();
    }
  };

  /**
   * Load filter options via API
   * Follows Uic-Form's DataFetchService pattern exactly
   * Supports: api, valuelist, and other fetch types
   */
  loadFilterOptions(col: ColorColumns) {
    const fetchType = this.getFilterDataFetchType(col);

    if (fetchType !== 'api' && fetchType !== 'valuelist') return;

    if (!col.filterDataFetchFrom) {
      console.warn(`[Filter] No API endpoint for column ${col.colName}`);
      return;
    }

    this.filterLoadingKey = col.colData;

    // Initialize selected filter values array if not already done
    if (!this.selectedFilterValues[col.colData]) {
      this.selectedFilterValues[col.colData] = [];
    }

    try {
      // Build the API URL
      let apiUrl = col.filterDataFetchFrom;
      
      // Add base URL if not absolute (like Uic-Form)
      if (!apiUrl.startsWith('http')) {
        apiUrl = environment.getApiUrl(apiUrl);
      }
      
      // Replace placeholders
      apiUrl = this.replacePlaceholdersInUrl(apiUrl, col);
      
      // Build query parameters (following Uic-Form pattern)
      const params = this.buildFilterQueryParams(col);
      
      console.log(`[Filter] Fetching options from: ${apiUrl}`);
      
      // Make API call with error handling (like Uic-Form)
      this.http.get<any>(apiUrl, { params }).pipe(
        map((response: any) => this.normalizeFilterResponse(response)),
        catchError((error) => {
          console.error(`[Filter] Error loading options for column ${col.colName}:`, error);
          return of([]);
        })
      ).subscribe({
        next: (items: any[]) => {
          this.filterOptions[col.colData] = items.map(item => ({
            key: item[col.filterDataPatchName!],
            value: item[col.filterDataDisplayName!]
          }));
          this.filterLoadingKey = null;
        }
      });
      
    } catch (error) {
      console.error(`[Filter] Exception loading options for column ${col.colName}:`, error);
      this.filterLoadingKey = null;
      this.filterOptions[col.colData] = [];
    }
  }

  /**
   * Build HTTP query parameters for filter API
   * (Matching Uic-Form's buildQueryParams pattern)
   */
  private buildFilterQueryParams(col: ColorColumns): HttpParams {
    let params = new HttpParams();
    
    // Add company and branch (like Uic-Form)
    params = params.set('CompanyId', this.User.companyId.toString());
    params = params.set('BranchId', this.User.loggedInBranchId.toString());
    
    // Add search term if provided
    const searchTerm = this.filterSearchText[col.colData];
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
      params = params.set('FilterValue', searchTerm);
    }
    
    return params;
  }

  /**
   * Replace placeholders in URL (matching Uic-Form pattern)
   * Handles: {{CompanyId}}, {{LoggedInCompanyId}}, {{BranchId}}, {{UserId}}, {{FilterValue}}, etc.
   */
  private replacePlaceholdersInUrl(url: string, col: ColorColumns): string {
    // System placeholders mapping (same as Uic-Form)
    const dynamicValues: Record<string, any> = {
      '{{CompanyId}}': this.User.companyId,
      '{{LoggedInCompanyId}}': this.User.companyId,
      '{{BranchId}}': this.User.loggedInBranchId,
      '{{UserId}}': this.User.userId.toString(),
      '{{FilterValue}}': this.filterSearchText[col.colData] 
        ? encodeURIComponent(this.filterSearchText[col.colData])
        : '{{FilterValue}}'
    };

    // Replace all placeholders
    let result = url;
    for (const key in dynamicValues) {
      result = result.replaceAll(key, dynamicValues[key]?.toString() ?? '');
    }

    return result;
  }

  /**
   * Normalize filter API response (same pattern as Uic-Form)
   * Looks for: items, data, result, or returns as-is if array
   */
  private normalizeFilterResponse(response: any): any[] {
    if (Array.isArray(response)) {
      return response;
    }

    if (response?.items && Array.isArray(response.items)) {
      return response.items;
    }

    if (response?.data && Array.isArray(response.data)) {
      return response.data;
    }

    if (response?.result && Array.isArray(response.result)) {
      return response.result;
    }

    if (typeof response === 'object' && response !== null) {
      return [response];
    }

    return [];
  }

  /**
   * Toggle a checkbox value in the filter
   */
  toggleFilterValue(columnKey: string, value: any) {
    if (!this.selectedFilterValues[columnKey]) {
      this.selectedFilterValues[columnKey] = [];
    }

    const arr = this.selectedFilterValues[columnKey];
    const index = arr.indexOf(value);

    if (index >= 0) {
      arr.splice(index, 1);
    } else {
      arr.push(value);
    }
  }

  /**
   * Check if a filter value is selected
   */
  isFilterValueSelected(columnKey: string, value: any): boolean {
    if (!this.selectedFilterValues[columnKey]) return false;
    return this.selectedFilterValues[columnKey].includes(value);
  }

  /**
   * Check if all filter options are selected for a column
   */
  isFilterSelectAllChecked(columnKey: string): boolean {
    const options = this.filterOptions[columnKey];
    const selected = this.selectedFilterValues[columnKey];

    if (!options || options.length === 0) return false;
    if (!selected || selected.length === 0) return false;

    return options.every(opt => selected.includes(opt.key));
  }

  /**
   * Toggle select all checkboxes for a filter column
   */
  toggleFilterSelectAll(columnKey: string) {
    const options = this.filterOptions[columnKey];
    if (!options || options.length === 0) return;

    const isAllSelected = this.isFilterSelectAllChecked(columnKey);

    if (isAllSelected) {
      // Uncheck all: clear the selection
      this.selectedFilterValues[columnKey] = [];
    } else {
      // Check all: select all option keys
      this.selectedFilterValues[columnKey] = options.map(opt => opt.key);
    }
  }

  /**
   * Apply filter on a column
   * Stores filter info and rebuilds WHERE clause with proper formatting
   * If filter is empty, removes the filter
   */
  applyFilter(col: ColorColumns, filterValues: any) {
    const columnKey = col.colData;
    const inputType = this.getFilterInputType(col);
    const fetchType = this.getFilterDataFetchType(col);
    const whereColumn = (col.whereClauseName || col.filterDataPatchName || '').trim();

    // Select+API needs patch key for mapping selected option keys from API response
    if (inputType === 'select' && fetchType === 'api' && !col.filterDataPatchName) {
      console.warn(`[Filter] Missing filterDataPatchName for select filter on column ${col.colName}`);
      return;
    }

    // Text/date filters can run with whereClauseName only
    if (inputType !== 'select' && !whereColumn) {
      console.warn(`[Filter] Missing whereClauseName/filterDataPatchName for filter on column ${col.colName}`);
      return;
    }

    // ========== CASE 1: SELECT + API (Multi-select dropdown) ==========
    if (inputType === 'select' && fetchType === 'api') {
      if (filterValues && filterValues.length > 0) {
        this.activeFilters[columnKey] = {
          columnKey,
          selectedValues: filterValues
        };
        // Keep UI state for display
        this.selectedFilterValues[columnKey] = filterValues;
      } else {
        // Remove filter if empty
        delete this.activeFilters[columnKey];
        delete this.selectedFilterValues[columnKey];
      }
      this.applyWhereClause('');
    }
    // ========== CASE 2: TEXTBOX + TEXT (Text search with LIKE) ==========
    else if (inputType === 'textbox' && fetchType === 'text') {
      if (filterValues && filterValues.trim()) {
        this.activeFilters[columnKey] = {
          columnKey,
          filterText: filterValues
        };
        // Keep UI state for display
        this.filterSearchText[columnKey] = filterValues;
      } else {
        // Remove filter if empty - clear both active filter and UI state
        delete this.activeFilters[columnKey];
        delete this.filterSearchText[columnKey];
      }
      this.applyWhereClause('');
    }
    // ========== CASE 3: DATE COLUMNS (Date range BETWEEN) ==========
    else if (inputType === 'date' || col.dataType?.toLowerCase() === 'date' || fetchType === 'date') {
      const normalizedDateFilter = this.normalizeAndValidateDateFilter(columnKey, filterValues);

      if (!normalizedDateFilter.isValid) {
        this.dateFilterValidationError[columnKey] = normalizedDateFilter.errorMessage || 'Invalid date filter';
        return;
      }

      this.dateFilterValidationError[columnKey] = '';
      this.dateFilterCondition[columnKey] = normalizedDateFilter.condition;

      if (normalizedDateFilter.hasFilterValue) {
        this.activeFilters[columnKey] = {
          columnKey,
          dateCondition: normalizedDateFilter.condition,
          filterDate: normalizedDateFilter.filterDate,
          filterFromDate: normalizedDateFilter.filterFromDate,
          filterToDate: normalizedDateFilter.filterToDate
        };
      } else {
        delete this.activeFilters[columnKey];
      }

      this.filterSearchText[columnKey] = normalizedDateFilter.filterDate || '';
      this.filterSearchText[columnKey + '_from'] = normalizedDateFilter.filterFromDate || '';
      this.filterSearchText[columnKey + '_to'] = normalizedDateFilter.filterToDate || '';

      this.applyWhereClause('');
    }

    this.closeFilterPopup();
    this.updateFilterQuery();
  }

  /**
   * Apply where clause and reload data
   */
  private applyWhereClause(newClause: string) {
    this.rebuildWhereClause();
    this.workingReadAllDTO.pageNo = 1;
    this.DataLoading = true;
    this.UICListService.GenericListData_ReadAllPaginated(this.workingReadAllDTO).subscribe(res => {
      this.setTableDataAndEmit(res);
      this.DataLoading = false;
    });
  }

  /**
   * Rebuild complete WHERE clause from parent clause + all active filters
   * Combines parent's WHERE clause with filter WHERE clauses using AND
   * Parent's WHERE clause is NEVER modified or stripped
   * Only modifies the WORKING COPY to prevent parent DTO mutation
   */
  private rebuildWhereClause() {
    const allFilterClauses = Object.values(this.activeFilters)
      .map(filter => this.buildFilterWhereClause(filter))
      .filter(clause => clause);

    // Build filter WHERE clause
    const filterWhereClause = allFilterClauses.length > 0
      ? allFilterClauses.join(' AND ')
      : '';

    // === CRITICAL: Combine parent's WHERE clause + filter WHERE clause ===
    // Parent's WHERE clause is NEVER modified or stripped
    const parentClause = (this.parentWhereClause || '').trim();
    
    // === Modify ONLY the working copy, never the original ReadAllDTO ===
    // Combine: if both exist, use AND
    if (parentClause && filterWhereClause) {
      this.workingReadAllDTO.whereClause = `(${parentClause}) AND (${filterWhereClause})`;
    } else if (filterWhereClause) {
      // Only filter clause exists
      this.workingReadAllDTO.whereClause = filterWhereClause;
    } else {
      // Only parent clause exists (or neither)
      this.workingReadAllDTO.whereClause = parentClause;
    }
  }

  /**
   * Build WHERE clause from a single filter
   * Uses whereClauseName for column reference and LIKE conditions for values
   * Escapes single quotes for SQL Server (doubles them)
   */
  private buildFilterWhereClause(filter: ActiveFilter): string {
    const col = this.columns.find(c => c.colData === filter.columnKey);
    if (!col) return '';

    // Use whereClauseName for the column reference (e.g., A.Status, Status, etc.)
    const whereClauseName = col.whereClauseName || col.filterDataPatchName;
    if (!whereClauseName) return '';

    // Multi-select (API) → Multiple LIKE conditions with OR
    if (filter.selectedValues && filter.selectedValues.length > 0) {
      const likeConditions = filter.selectedValues.map(value => 
        `${whereClauseName} LIKE ''%${value}%''`  // Double single quotes for SQL Server
      );

      if (likeConditions.length === 1) {
        // Single selection: no need for parentheses
        return likeConditions[0];
      } else {
        // Multiple selections: wrap with parentheses and OR them (clean format for SQL Server)
        return `(${likeConditions.join(' OR ')})`;
      }
    }
    
    // Text search → LIKE clause
    if (filter.filterText) {
      return `${whereClauseName} LIKE ''%${filter.filterText}%''`;  // Double single quotes for SQL Server
    }
    
    // Date filters → condition-based clause
    if (filter.dateCondition || filter.filterDate || filter.filterFromDate || filter.filterToDate) {
      const resolvedCondition = this.resolveDateCondition(filter);
      const filterDate = this.normalizeDateValue(filter.filterDate || filter.filterFromDate || filter.filterToDate || '');
      const fromDate = this.normalizeDateValue(filter.filterFromDate || '');
      const toDate = this.normalizeDateValue(filter.filterToDate || '');

      if (resolvedCondition === 'between') {
        if (!fromDate || !toDate) return '';
        return `${whereClauseName} BETWEEN ''${fromDate}'' AND ''${toDate}''`;
      }

      if (!filterDate) return '';

      if (resolvedCondition === 'gt') {
        return `${whereClauseName} > ''${filterDate}''`;
      }

      if (resolvedCondition === 'lt') {
        return `${whereClauseName} < ''${filterDate}''`;
      }

      return `${whereClauseName} = ''${filterDate}''`;
    }

    return '';
  }

  /**
   * Clear filter on a specific column
   */
  clearColumnFilter(columnKey: string) {
    delete this.activeFilters[columnKey];
    
    // Clear UI state for this column
    delete this.filterSearchText[columnKey];
    delete this.filterSearchText[columnKey + '_from'];
    delete this.filterSearchText[columnKey + '_to'];
    delete this.selectedFilterValues[columnKey];
    delete this.dateFilterCondition[columnKey];
    delete this.dateFilterValidationError[columnKey];

    // Rebuild WHERE clause from remaining filters + parent's WHERE clause
    this.rebuildWhereClause();
    this.workingReadAllDTO.pageNo = 1;

    this.DataLoading = true;
    this.UICListService.GenericListData_ReadAllPaginated(this.workingReadAllDTO).subscribe(res => {
      this.setTableDataAndEmit(res);
      this.DataLoading = false;
    });
    this.updateFilterQuery();
  }

  /**
   * Clear all filters
   */
  clearAllFilters() {
    this.activeFilters = {};
    // Also clear all UI state
    this.filterSearchText = {};
    this.selectedFilterValues = {};
    this.dateFilterCondition = {};
    this.dateFilterValidationError = {};
    
    // Reset WHERE clause to parent's clause only (preserve parent search)
    this.workingReadAllDTO.whereClause = (this.parentWhereClause || '').trim();
    this.workingReadAllDTO.pageNo = 1;

    this.DataLoading = true;
    this.UICListService.GenericListData_ReadAllPaginated(this.workingReadAllDTO).subscribe(res => {
      this.setTableDataAndEmit(res);
      this.DataLoading = false;
    });
    this.updateFilterQuery();
  }

  /**
   * Serialize active filters to query params
   * Converts filters object to JSON and URL encodes it
   */
  private serializeFiltersToQueryParam(): string | null {
    if (Object.keys(this.activeFilters).length === 0) {
      return null;
    }

    try {
      const filterData = Object.values(this.activeFilters).map(filter => ({
        columnKey: filter.columnKey,
        selectedValues: filter.selectedValues || [],
        filterText: filter.filterText || '',
        dateCondition: filter.dateCondition || '',
        filterDate: filter.filterDate || '',
        filterFromDate: filter.filterFromDate || '',
        filterToDate: filter.filterToDate || ''
      }));

      return encodeURIComponent(JSON.stringify(filterData));
    } catch (error) {
      console.error('[Filter] Error serializing filters:', error);
      return null;
    }
  }

  /**
   * Update filter query params
   * Saves current active filters to URL query parameters
   */
  private updateFilterQuery() {
    const paramValue = this.serializeFiltersToQueryParam();

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        [this.filterConfigQueryParam]: paramValue ?? encodeURIComponent('[]')
      },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  /**
   * Deserialize filters from query params
   * Converts URL-encoded JSON back to activeFilters object
   */
  private deserializeFiltersFromQueryParam(encodedValue: string): { [key: string]: ActiveFilter } {
    try {
      const decoded = decodeURIComponent(encodedValue);
      const filterArray = JSON.parse(decoded) as any[];

      const filters: { [key: string]: ActiveFilter } = {};

      filterArray.forEach(filterItem => {
        filters[filterItem.columnKey] = {
          columnKey: filterItem.columnKey,
          selectedValues: filterItem.selectedValues || [],
          filterText: filterItem.filterText || '',
          dateCondition: filterItem.dateCondition || undefined,
          filterDate: filterItem.filterDate || '',
          filterFromDate: filterItem.filterFromDate || '',
          filterToDate: filterItem.filterToDate || ''
        };
      });

      return filters;
    } catch (error) {
      console.error('[Filter] Error deserializing filters from query:', error);
      return {};
    }
  }

  /**
   * Apply filters from query params on page load
   * Restores previously saved filters from URL and updates UI state
   */
  private applyFiltersFromQuery() {
    if (!this.columns.length) return;

    const rawValue = this.route.snapshot.queryParamMap.get(this.filterConfigQueryParam);
    if (!rawValue) return;

    const restoredFilters = this.deserializeFiltersFromQueryParam(rawValue);
    if (Object.keys(restoredFilters).length === 0) {
      this.activeFilters = {};
      this.restoreFilterUIState();
      return;
    }

    const meaningfulFilters: { [key: string]: ActiveFilter } = {};
    Object.entries(restoredFilters).forEach(([columnKey, filter]) => {
      if (this.hasFilterValue(filter)) {
        meaningfulFilters[columnKey] = filter;
      }
    });

    if (Object.keys(meaningfulFilters).length === 0) {
      this.activeFilters = {};
      this.restoreFilterUIState();
      return;
    }

    this.activeFilters = meaningfulFilters;
    
    // === CRITICAL: Restore UI state for filter inputs ===
    this.restoreFilterUIState();

    // Build WHERE clause and hit API using the shared flow
    this.applyWhereClause('');
  }

  private hasFilterValue(filter: ActiveFilter): boolean {
    if (filter.selectedValues && filter.selectedValues.length > 0) return true;
    if (filter.filterText && filter.filterText.trim()) return true;
    if (filter.filterDate) return true;
    if (filter.filterFromDate || filter.filterToDate) return true;
    return false;
  }

  /**
   * Restore filter UI state from activeFilters
   * Populates filterSearchText and selectedFilterValues so UI shows restored values
   */
  private restoreFilterUIState() {
    // Clear existing UI state
    this.filterSearchText = {};
    this.selectedFilterValues = {};
    this.dateFilterCondition = {};
    this.dateFilterValidationError = {};

    // Restore from activeFilters
    Object.entries(this.activeFilters).forEach(([columnKey, filter]) => {
      // Restore search text for textbox filters
      if (filter.filterText) {
        this.filterSearchText[columnKey] = filter.filterText;
      }

      // Restore selected values for select/checkbox filters
      if (filter.selectedValues && filter.selectedValues.length > 0) {
        this.selectedFilterValues[columnKey] = [...filter.selectedValues];
      }

      if (filter.dateCondition || filter.filterDate || filter.filterFromDate || filter.filterToDate) {
        const resolvedCondition = this.resolveDateCondition(filter);
        this.dateFilterCondition[columnKey] = resolvedCondition;

        if (resolvedCondition === 'between') {
          this.filterSearchText[columnKey + '_from'] = filter.filterFromDate || '';
          this.filterSearchText[columnKey + '_to'] = filter.filterToDate || '';
        } else {
          this.filterSearchText[columnKey] = filter.filterDate || filter.filterFromDate || filter.filterToDate || '';
        }
      }
    });
  }

  private normalizeDateValue(dateValue: string): string {
    const value = (dateValue || '').trim();
    if (!value) return '';

    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }

    const parsedDate = new Date(value);
    if (isNaN(parsedDate.getTime())) {
      return '';
    }

    const year = parsedDate.getFullYear();
    const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
    const day = String(parsedDate.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private resolveDateCondition(filter?: ActiveFilter): DateFilterCondition {
    if (!filter) return 'eq';
    if (filter.dateCondition) return filter.dateCondition;

    if (filter.filterFromDate && filter.filterToDate) return 'between';
    if (filter.filterFromDate && !filter.filterToDate) return 'gt';
    if (filter.filterToDate && !filter.filterFromDate) return 'lt';

    return 'eq';
  }

  private normalizeAndValidateDateFilter(
    columnKey: string,
    filterValues: any
  ): {
    isValid: boolean;
    errorMessage?: string;
    condition: DateFilterCondition;
    filterDate: string;
    filterFromDate: string;
    filterToDate: string;
    hasFilterValue: boolean;
  } {
    const incomingCondition = (filterValues?.condition || this.dateFilterCondition[columnKey] || 'eq') as DateFilterCondition;
    const condition: DateFilterCondition = ['eq', 'gt', 'lt', 'between'].includes(incomingCondition)
      ? incomingCondition
      : 'eq';

    if (filterValues?.clear === true) {
      return {
        isValid: true,
        condition,
        filterDate: '',
        filterFromDate: '',
        filterToDate: '',
        hasFilterValue: false
      };
    }

    const filterDate = this.normalizeDateValue(filterValues?.date || '');
    const filterFromDate = this.normalizeDateValue(filterValues?.fromDate || '');
    const filterToDate = this.normalizeDateValue(filterValues?.toDate || '');

    if (condition === 'between') {
      const hasAnyBetweenDate = !!(filterFromDate || filterToDate);
      if (!hasAnyBetweenDate) {
        return {
          isValid: false,
          errorMessage: 'Please select both From Date and To Date.',
          condition,
          filterDate: '',
          filterFromDate: '',
          filterToDate: '',
          hasFilterValue: false
        };
      }

      if (!filterFromDate || !filterToDate) {
        return {
          isValid: false,
          errorMessage: 'Please select both From Date and To Date.',
          condition,
          filterDate: '',
          filterFromDate,
          filterToDate,
          hasFilterValue: false
        };
      }

      if (filterFromDate > filterToDate) {
        return {
          isValid: false,
          errorMessage: 'From Date cannot be greater than To Date.',
          condition,
          filterDate: '',
          filterFromDate,
          filterToDate,
          hasFilterValue: false
        };
      }

      return {
        isValid: true,
        condition,
        filterDate: '',
        filterFromDate,
        filterToDate,
        hasFilterValue: true
      };
    }

    if (!filterDate) {
      return {
        isValid: false,
        errorMessage: 'Please select a date.',
        condition,
        filterDate: '',
        filterFromDate: '',
        filterToDate: '',
        hasFilterValue: false
      };
    }

    return {
      isValid: true,
      condition,
      filterDate,
      filterFromDate: '',
      filterToDate: '',
      hasFilterValue: true
    };
  }

}

